import Skeleton from "react-loading-skeleton";

export default function SizeGuideSkeleton() {
    return (
        <div className="styleguide-skeleton">
            <Skeleton height={470} />
            <Skeleton width="40%" height={30} style={{ margin: "40px auto" }} />
            <Skeleton height={400} />
        </div>
    );
}
